import React from "react";
import { Modal, Button } from "react-bootstrap";
import { Contact } from './contactApi';

interface DeleteContactModalProps {
    show: boolean;
    onHide: () => void;
    onConfirm: () => void;
    selectedContact: Contact | null;
    loading?: boolean;
}

const DeleteContactModal: React.FC<DeleteContactModalProps> = ({ 
    show, 
    onHide, 
    onConfirm, 
    selectedContact,
    loading = false 
}) => {
    return (
        <Modal className="delete-modal" show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Delete Contact?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Are you sure you want to delete <strong>{selectedContact?.name}</strong>? 
                    <br />
                    This action cannot be undone.
                </p>
                {selectedContact?.isPrimaryLegacyContact && (
                    <div className="alert alert-warning mt-2">
                        <small>
                            <strong>Warning:</strong> This is your Primary Legacy Contact. 
                            Deleting this contact will remove their legacy status.
                        </small>
                    </div>
                )}
                {selectedContact?.isSecondaryLegacyContact && (
                    <div className="alert alert-warning mt-2">
                        <small>
                            <strong>Warning:</strong> This is your Secondary Legacy Contact. 
                            Deleting this contact will remove their legacy status.
                        </small>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button 
                    className="blue-outline-bttn" 
                    onClick={onHide}
                    disabled={loading}
                >
                    Cancel
                </Button>
                <Button 
                    className="bttn" 
                    onClick={onConfirm}
                    disabled={loading}
                >
                    {loading ? 'Deleting...' : 'Delete'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteContactModal;